import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { AdminService } from 'src/app/services/admin.service';

@Component({
  selector: 'app-add-point-agent',
  templateUrl: './add-point-agent.component.html',
  styleUrls: ['./add-point-agent.component.scss']
})
export class AddPointAgentComponent implements OnInit {
  pointForm!: FormGroup;
  userId: number = 0;
  loader: boolean = false;

  constructor(
    private activeroute: ActivatedRoute,
    private adminservice: AdminService,
    private dialogRef: MatDialogRef<AddPointAgentComponent>
  ) { }

  ngOnInit() {
    this.activeroute.queryParams.subscribe(params => {
      this.userId = +params['userId'];
    });
    this.formBuilder();
  }

  formBuilder(){
    this.pointForm = new FormGroup({
      points: new FormControl('', Validators.required),
      amount: new FormControl('', Validators.required)
    });
  }

  savePoints(){
    if (!this.pointForm.valid) {
      return
    }

    const request = {
      asesor_id: this.userId,
      punto_kaizen: +this.pointForm.value.points,
      monto: +this.pointForm.value.amount
    }
    this.loader = true;
    this.adminservice.savePoints(request).subscribe(
      (response)=>{
        this.loader = false;
        if (response.rtn) {
          this.dialogRef.close(true)
        }
      }
    );
  }

  keypressNumbers(event: any) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  
}
